const DASHBOARD_ROUTES = {
  event_manager: '/home',
  manager: '/home',
  team_member: '/dashboard/tasks',
  staff: '/dashboard/tasks',
  hotel_manager: '/dashboard/rooms?tab=arrivals',
  bride: '/couple',
  groom: '/couple',
  host: '/host',
  admin_guest: '/guest',
  guest: '/guest',
};

export const getDashboardPath = (role) => DASHBOARD_ROUTES[role] || '/dashboard';

export const getSafeReturnPath = (value) => {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) {
    return null;
  }

  try {
    const base = 'https://galago.local';
    const parsed = new URL(value, base);
    if (parsed.origin !== base || ['/login', '/register'].includes(parsed.pathname)) {
      return null;
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch (_error) {
    return null;
  }
};

export const getAppEntryPath = ({ user, effectiveRole } = {}) => (
  user ? getDashboardPath(effectiveRole || user.role) : '/login'
);
